export const getTextFieldWithSuffixStyles = () => {
  const textFieldWithSuffix = {
    display: 'flex',
    flexDirection: 'row',
  };

  return {
    textFieldWithSuffix,
  };
};

export const unitStyles = {
  root: {
    alignSelf: 'center',
  },
};
